export default import.meta.ROLLUP_FILE_URL_ypXq9ucusNStulS9niBW2w